const PQL_UPGRADE_PRODUCT = Object.freeze({
  MARKETING_STARTER: 'marketing-starter',
  MARKETING_PROFESSIONAL: 'marketing-pro',
  MARKETING_ENTERPRISE: 'marketing-enterprise'
});
export default PQL_UPGRADE_PRODUCT;